module.exports = __webpack_public_path__ + "img/top-arrow.5f57d03a.svg";